/**
 * ClientList module for calling the back end to probision data
 */
export const ClientList = (function () {

  function provision() {

     // Get the data from fields with the client-list-field 
     var pds_data = {};
     var elements = document.getElementsByClassName('client-list-field');
     Array.from(elements).forEach(element => {
        pds_data[ element.getAttribute('name') ] = element.value;
     });

     var csrf = Util.getCSRF();
     return $.ajax({
         url: '/inapp/provision',
         type: 'post',
         headers: { 'x-csrf-token': csrf },
         data: {
             pds_data : pds_data
         }
     })
 }
 return {
   provision: provision
 }

}());